export const FETCH_QUOTES_REQUEST = 'FETCH_QUOTES_REQUEST';
export const FETCH_QUOTES_SUCCESS = 'FETCH_QUOTES_SUCCESS';
export const FETCH_QUOTES_FAILURE = 'FETCH_QUOTES_FAILURE';

export const FETCH_QUOTE_REQUEST = 'FETCH_QUOTE_REQUEST';
export const FETCH_QUOTE_SUCCESS = 'FETCH_QUOTE_SUCCESS';
export const FETCH_QUOTE_FAILURE = 'FETCH_QUOTE_FAILURE';

export const UPDATE_QUOTES_REQUEST = 'UPDATE_QUOTES_REQUEST';
export const UPDATE_QUOTES_SUCCESS = 'UPDATE_QUOTES_SUCCESS';
export const UPDATE_QUOTES_FAILURE = 'UPDATE_QUOTES_FAILURE';

export const DELETE_QUOTES_REQUEST = 'DELETE_QUOTES_REQUEST';
export const DELETE_QUOTES_SUCCESS = 'DELETE_QUOTES_SUCCESS';
export const DELETE_QUOTES_FAILURE = 'DELETE_QUOTES_FAILURE';

export const CREATE_QUOTE_REQUEST = 'CREATE_QUOTE_REQUEST';
export const CREATE_QUOTE_SUCCESS = 'CREATE_QUOTE_SUCCESS';
export const CREATE_QUOTE_FAILURE = 'CREATE_QUOTE_FAILURE';

export const QUOTE_TO_PDF_REQUEST = 'QUOTE_TO_PDF_REQUEST';
export const QUOTE_TO_PDF_SUCCESS = 'QUOTE_TO_PDF_SUCCESS';
export const QUOTE_TO_PDF_FAILURE = 'QUOTE_TO_PDF_FAILURE';

export const CLEAR_QUOTE_ERRORS = 'CLEAR_QUOTE_ERRORS';
export const CLEAR_QUOTE_SUCCESS = 'CLEAR_QUOTE_SUCCESS';